import { Component, OnInit } from '@angular/core';
import {cIOMAPPEDCOUNTER, CounterStatus} from "../../counter/counterStatus";
import {interval, Subscription} from "rxjs";
import {CounterdetailsComponent} from "../../counter/counterdetails/counterdetails.component";
import {CounterStatusDataservice} from "../../counter/counter-status-dataservice";
import {environment} from "../../../environments/environment";
import {ComplexDevicesDataService} from "../ComplexDevicesDataService";
import {cIO_COMPLEX_DEVICE, ComplexDevices} from "../complexDevices";
import {eCPXDEV_TYPE} from "../eCPXDEV_TYPE";

@Component({
  selector: 'app-complex-devices-list',
  templateUrl: './complex-devices-list.component.html',
  styleUrls: ['./complex-devices-list.component.css']
})
export class ComplexDevicesListComponent implements OnInit {
  private updateSubscription: Subscription | undefined;
  complexDevices: cIO_COMPLEX_DEVICE[] = Array();
  private errorMessage: string = "";
  readonly eCPXDEV_TYPE: typeof eCPXDEV_TYPE = eCPXDEV_TYPE;

  constructor(private complexDevicesDataService: ComplexDevicesDataService)
  {
  }

  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.complexDevicesDataService.GetData().subscribe(
      {
        next: complexDevices => {
          this.complexDevices = complexDevices.cIO_COMPLEX_DEVICE;
          this.ReSubscribe();
        }, error: err => this.errorMessage = err
      });
  }

  ngOnInit(): void {
    this.UpdateData();
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }



}
